module.exports = __webpack_public_path__ + "static/media/pic3.34a4ed08.jpg";